// @flow

import createAction from 'redux-actions/lib/createAction';

// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

type ClearPersonalisedContentActionType = 'PERSONAL_CONTENT:CLEAR_PERSONAL_CONTENT';

export type ClearPersonalisedContentAction = {|
  type: ClearPersonalisedContentActionType,
  payload: {||},
  meta: {||},
|};


// -----------------------------------------------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------------------------------------------

const type: ClearPersonalisedContentActionType = 'PERSONAL_CONTENT:CLEAR_PERSONAL_CONTENT';


// -----------------------------------------------------------------------------------------------------------------
// Action
// -----------------------------------------------------------------------------------------------------------------

const clearPersonalContent: (void) => ClearPersonalisedContentAction = createAction(type);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default clearPersonalContent;



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/actions/clearPersonalContent.js